import {
  DocumentTextIcon,
} from '@heroicons/react/24/outline';
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

import AuthenticatedRoute from "./common/components/AuthenticatedRoute";
import AuthenticationCallback from "./common/components/AuthenticationCallback";
import LogoutCallback from "./common/components/LogoutCallback";
import EmailChange from "./common/pages/EmailChange";
import PageNotFound from "./common/pages/PageNotFound";
import PasswordChange from "./common/pages/PasswordChange";
import PhoneNumberChange from "./common/pages/PhoneNumberChange";
import ProfileUpdate from "./common/pages/ProfileUpdate";
import RegisterResult from "./pages/RegisterResult";
import ProviderDashboard from "./pages/ProviderDashboard";
import RsaKitsDashboard from "./pages/RsaKitsDashboard";
import UpdateResult from "./pages/UpdateResult";

const navigation = [
  { name: "PBS Analysis Kits", href: "/kits", icon: DocumentTextIcon },
  { name: "RSA Kits", href: "/rsa-kits", icon: DocumentTextIcon },
];

const userNavigation = [
  { name: "Update profile", href: "/profile-update" },
  { name: "Change email", href: "/email-change" },
  { name: "Change phone number", href: "/phone-number-change" },
  { name: "Change password", href: "/password-change" },
  { name: "Sign out", href: "/auth/logout" },
];

function App() {
  // Handle basename for development vs production
  const basename = process.env.NODE_ENV === 'development' ? undefined : process.env.PUBLIC_URL;

  return (
    <Router basename={basename}>
      <div className="w-full mx-auto">
        <Routes>
          <Route path="/" element={<Navigate to="/kits" />} />
          <Route
            path="/kits"
            element={
              <AuthenticatedRoute
                component={ProviderDashboard}
                title="View Analysis Kits"
                navigation={navigation}
                userNavigation={userNavigation}
              />
            }
          />
          <Route
            path="/rsa-kits"
            element={
              <AuthenticatedRoute
                component={RsaKitsDashboard}
                title="View RSA Kits"
                navigation={navigation}
                userNavigation={userNavigation}
              />
            }
          />
          <Route
            path="/register-result/:id"
            element={
              <AuthenticatedRoute
                component={RegisterResult}
                title="Register analysis kit results"
                navigation={navigation}
                userNavigation={userNavigation}
              />
            }
          />
          <Route
            path="/update-result/:id"
            element={
              <AuthenticatedRoute
                component={UpdateResult}
                title="Update analysis kit results"
                navigation={navigation}
                userNavigation={userNavigation}
              />
            }
          />
          <Route
            path="/profile-update"
            element={
              <AuthenticatedRoute
                component={ProfileUpdate}
                title="Profile update"
                navigation={navigation}
                userNavigation={userNavigation}
              />
            }
          />
          <Route
            path="/password-change"
            element={
              <AuthenticatedRoute
                component={PasswordChange}
                title="Password change"
                navigation={navigation}
                userNavigation={userNavigation}
              />
            }
          />
          <Route
            path="/email-change"
            element={
              <AuthenticatedRoute
                component={EmailChange}
                title="Email change"
                navigation={navigation}
                userNavigation={userNavigation}
              />
            }
          />
          <Route
            path="/phone-number-change"
            element={
              <AuthenticatedRoute
                component={PhoneNumberChange}
                title="Phone number change"
                navigation={navigation}
                userNavigation={userNavigation}
              />
            }
          />
          <Route path="/auth/login" element={<AuthenticationCallback />} />
          <Route path="/auth/logout" element={<LogoutCallback />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>

        <ToastContainer autoClose={3000} />
      </div>
    </Router>
  );
}

export default App;
